import { render } from "./ConnectFlowDetailPage.vue?vue&type=template&id=22e00c1f&ts=true"
import script from "./ConnectFlowDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/ConnectFlowDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22e00c1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22e00c1f', __exports__)) {
    api.reload('22e00c1f', __exports__)
  }
  
  module.hot.accept("./ConnectFlowDetailPage.vue?vue&type=template&id=22e00c1f&ts=true", () => {
    api.rerender('22e00c1f', render)
  })

}


export default __exports__